var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { Envs } from '../entities/Utils';
export default class ContentAPIService {
    constructor(props) {
        this.load = (file) => __awaiter(this, void 0, void 0, function* () {
            if (this.hasLocalContent) {
                const { data } = yield axios.get(`http://localhost:12321/${file}`);
                return data;
            }
            const signature = yield this.getContentSignature;
            const environment = this.environment === Envs.production ? 'production' : 'sandbox';
            const { data } = yield axios.get(`https://storage.googleapis.com/firebase-albert-${environment}-app-content/texts/${signature}/${file}`);
            return data;
        });
        this.environment = props.environment;
        this.getContentSignature = props.getContentSignature;
    }
    get hasLocalContent() {
        if (['development', 'test'].includes(String(process.env.NODE_ENV))) {
            const prefixes = ['', 'REACT_APP_', 'NEXT_PUBLIC_'];
            return prefixes.some((prefix) => !!process.env[`${prefix}USE_LOCAL_CONTENT`]);
        }
        return false;
    }
}
//# sourceMappingURL=contentAPIService.js.map